import React from 'react';
import Header from '../../components/header/header';
import './leadership.scss';
import { motion } from "motion/react";

const Leadership = () => {
  return (
    <div className="leadership">
      <Header />

      {/* Hero Section */}
      <section className="hero5">
        <div className="hero-content5">
          <h1>Our Leadership Team</h1>
          <p>Meet the dedicated pastors and leaders serving our church family</p>
        </div>
      </section>

      {/* Intro Section - Fade + Rotate */}
      <motion.section
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="section5"
      >
        <div className="section-header5">
          <h2 className="section-title5">Shepherding with Purpose</h2>
          <p className="section-subtitle5">Our leadership team is committed to serving God and guiding our congregation with wisdom, compassion, and biblical truth. Each leader brings unique gifts and a heart for ministry.</p>
        </div>
      </motion.section>

      {/* From the Pastor's Desk Section - Slide from left */}
      <motion.section 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className='past-desk'
      >
        <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 4%' }}>
          <div className="split-section5" style={{ gap: '5rem' }}>
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="split-image5" 
              style={{ height: '500px', borderRadius: '4px' }}
            >
              <img src="https://res.cloudinary.com/dsnontai6/image/upload/v1771182194/6Y5A3984_vmgkxl_0e4e22.jpg" alt="Pastor Charles Salako" style={{ width: '100%', height: '100%', borderRadius: '8px', objectFit: 'cover', objectPosition: 'top center' }} />
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="split-content5"
            >
              <p style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.95rem', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '1rem' }}>Lead Pastors</p>
              <h2 style={{ color: 'var(--white)', fontFamily: "'Playfair Display', serif", fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 700, marginBottom: '1.5rem', letterSpacing: '-1px', lineHeight: 1.2 }}>Pastor Charles & Adeola Salako</h2>
              <p className='lead-past'>
                Pastor Charles has been serving as Lead Pastor of RCCG Amazing Grace since 2007. With a passion for teaching God's Word and building authentic community, he leads our congregation with vision and compassion.
              </p>
              <p className='lead-past'>
                He and his wife have been married for almost 30 years and have three children. Pastor Charles's heart is to see every person encounter the transforming love of Jesus and discover their God-given purpose.
              </p>
              <div className='lead-past2'>
                {/* <div className="contact-item5" style={{ marginBottom: '1rem', color: 'rgba(255, 255, 255, 0.9)' }}>
                  <span className="contact-icon5">📧</span>
                  <a href="mailto:pastor@rccgag.org" style={{ color: 'rgba(255, 255, 255, 0.9)', textDecoration: 'none' }}>pastor@rccgagcde.com</a>
                </div> */}
                <div className="contact-item5" style={{ color: 'rgba(255, 255, 255, 0.9)' }}>
                  <span className="contact-icon5">📞</span>
                  <a href="tel:3024650760" style={{ color: 'rgba(255, 255, 255, 0.9)', textDecoration: 'none' }}>(302) 465-0760</a>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* Leadership Team Grid - Stagger animation */}
      <motion.section 
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.6 }}
        className="section"
      >
        <div className="section-header">
          <h2 className="section-title5">Pastoral Team</h2>
        </div>

        <div className="leadership-grid">
          
          {[
            {
              img: "https://res.cloudinary.com/dsnontai6/image/upload/v1771181374/R6II9865_iglarq.jpg",
              name: "Pastor Obi Atuokwu",
              position: "Assistant Pastor",
              bio: "Pastor Obi oversees our worship ministry and women's programs. He has a heart for authentic worship and discipleship, helping women grow in their faith and discover their purpose in Christ.",
              email: "obi@rccgag.org",
              phone: "(302) 465-0760 ext. 102"
            },
            {
              img: "https://res.cloudinary.com/dsnontai6/image/upload/v1771181375/0A3A5689_axppfu.jpg",
              name: "Pastor Osita Ogbunamiri",
              position: "Associate Pastor",
              bio: "Pastor Osita leads our youth ministry with energy and passion. He connects with students through relevant teaching, mentorship, and fun activities that build lasting faith foundations.",
              email: "osita@rccgag.org",
              phone: "(302) 465-0760 ext. 103",
              objectPosition: "center 25%"
            },
            // {
            //   img: "https://res.cloudinary.com/dsnontai6/image/upload/v1771182332/0A3A3227_kkcxsu.jpg",
            //   name: "Pastor Sarah Martinez",
            //   position: "Children's Pastor",
            //   bio: "Pastor Sarah oversees our children's ministry, creating engaging and safe environments where kids can learn about Jesus. She has a special gift for making Bible stories come alive for young hearts.",
            //   email: "sarah@rccgag.org",
            //   phone: "(302) 465-0760 ext. 104"
            // },
            // {
            //   img: "https://images.pexels.com/photos/5212317/pexels-photo-5212317.jpeg",
            //   name: "Pastor Emmanuel Akinola",
            //   position: "Outreach Pastor",
            //   bio: "Pastor Emmanuel leads our community outreach and missions efforts. He is passionate about serving the less fortunate and sharing God's love through practical acts of compassion.",
            //   email: "emmanuel@rccgag.org",
            //   phone: "(302) 465-0760 ext. 105"
            // },
            // {
            //   img: "https://images.pexels.com/photos/3184638/pexels-photo-3184638.jpeg",
            //   name: "Michael Chen",
            //   position: "Worship Director",
            //   bio: "Michael leads our worship team with excellence and heart. A gifted musician and songwriter, he creates spaces where people can encounter God through authentic worship and praise.",
            //   email: "worship@rccgag.org",
            //   phone: "(302) 465-0760 ext. 106"
            // },
            // {
            //   img: "https://images.pexels.com/photos/3760613/pexels-photo-3760613.jpeg",
            //   name: "Linda Thompson",
            //   position: "Church Administrator",
            //   bio: "Linda oversees our church operations and administration. With her organizational skills and servant heart, she ensures everything runs smoothly so our ministry can thrive.",
            //   email: "admin@rccgag.org",
            //   phone: "(302) 465-0760 ext. 100"
            // }
          ].map((leader, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="leader-card"
            >
              <div className="leader-image">
                <img src={leader.img} alt={leader.name} style={{objectPosition: leader.objectPosition || "center"}}/>
              </div>
              <div className="leader-content">
                <h3 className="leader-name">{leader.name}</h3>
                <p className="leader-position">{leader.position}</p>
                {/* <p className="leader-bio">{leader.bio}</p> */}
                {/* <div className="leader-contact">
                  <div className="contact-item5">
                    <span className="contact-icon5">📧</span>
                    <a href={`mailto:${leader.email}`}>{leader.email}</a>
                  </div>
                  <div className="contact-item5">
                    <span className="contact-icon5">📞</span>
                    <a href={`tel:${leader.phone.replace(/[^0-9]/g, '')}`}>{leader.phone}</a>
                  </div>
                </div> */}
              </div>
            </motion.div>
          ))}

        </div>
      </motion.section>
    </div>
  );
};

export default Leadership;
